export enum API_VERSIONS {
  v2 = 'apiUrlV2',
  v3 = 'apiUrlV3',
  v4 = 'apiUrlV4',
}
